(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-body"] && !Shopify.designMode) return;
  try {
    
const goalifyTrigger = document.getElementById('CartPageForm');
const goalifySource = document.getElementById('progress-bar-ninety9-block-cart');
const goalifyDestination1 = document.querySelector('#CartPageForm>div.cart__page').firstElementChild;
//const goalifyDestination1 = document.querySelector('#CartPageForm>div.cart__page');
const goalifyDestination2 = document.querySelector('#CartPageForm>div.cart__page').lastElementChild;
goalifyDestination1.prepend(goalifySource);
//goalifyDestination1.insertBefore(goalifySource, goalifyDestination1.firstElementChild);

const goalifyLayoutUpdate = (MutationList, observer) => {
  var goalifyRemove = document.getElementById('goalifyDesktopOnly');
  if (goalifyRemove) goalifyRemove.remove();
  var goalifyDuplicate = goalifySource.cloneNode(true);
  goalifyDuplicate.id = "goalifyDesktopOnly";
  goalifyDestination2.prepend(goalifyDuplicate);
  goalifyResizeObserver.observe(document.querySelector('#progress-bar-ninety9-block-cart .n99gb-drawer-bar div div div div div'));
};
const observerOptions = {
  childList: true,
  subtree: true,
  characterData: true,
};
const goalifyMutationObserver = new MutationObserver(goalifyLayoutUpdate);
goalifyMutationObserver.observe(goalifySource, observerOptions);

const goalifyResizeObserver = new ResizeObserver(goalifyLayoutUpdate);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-full-width"]) return;
  try {
    
var cookie_pref_button = document.querySelector("button.isense-reopen-widget-button");
cookie_pref_button.addEventListener("click", function (event) {
  showPreferences(this);event.preventDefault();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
var cookie_pref_button = document.querySelector("button.isense-reopen-widget-button");
cookie_pref_button.addEventListener("click", function (event) {
  showPreferences(this);event.preventDefault();
});

  } catch(e) { console.error(e); }
})();
})();
